import CollegePillActions from './constants';
import { IActionObject } from './types';

const INITIAL_STATE: string[] = [];

export default function collegePillReducer(
  state: string[] = INITIAL_STATE,
  action: IActionObject
): string[] {
  switch (action.type) {
    case CollegePillActions.ADD_COLLEGE_PILL:
      const filteredState = state.filter(
        (pill: any) => pill.value !== action.data.value
      );
      return [...filteredState, action.data];
    case CollegePillActions.REMOVE_COLLEGE_PILL:
      return state.filter((pill: any) => pill.value !== action.data.value);
    default:
      return state;
  }
}
